import { render, staticRenderFns } from "./systemNotify.vue?vue&type=template&id=e84fa192&"
import script from "./systemNotify.vue?vue&type=script&lang=js&"
export * from "./systemNotify.vue?vue&type=script&lang=js&"
import style0 from "./systemNotify.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports